import { createSlice } from "@reduxjs/toolkit";

export const scrollSlice = createSlice({
  name: "scroll",
  initialState: {
    position: 0,
  },
  reducers: {
    setScrollPosition: (state, action) => {
      state.position = action.payload;
    },
  },
});

export const { setScrollPosition } = scrollSlice.actions;

export default scrollSlice.reducer;
